class SearchData{
    constructor(language, game, genre){
        this.language=language;
        this.game = game;
        this.genre = genre;
    }
}

export default SearchData